module.exports = __webpack_public_path__ + "d3256c12c35098869b87ce68bef9d1c2.fbx";